import { useState } from "react";
import { Box, Tab, Tabs, Typography, Stack } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import Templete from "../../template/Template";
import TabAsaas from "./TabAsaas";
import TabKanban from "./TabKanban";

export default function Configuracoes() {
    const [tab, setTab] = useState(0);

    return (
        <Templete menuActive="configuracoes">
            <Box sx={{ mb: 2 }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <SettingsIcon color="primary" />
                    <Typography variant="h5" fontWeight="bold">Configurações</Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                    Gerencie as configurações do seu escritório
                </Typography>
            </Box>

            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                sx={{ borderBottom: '1px solid', borderColor: 'divider', mb: 3 }}
            >
                <Tab label="Asaas" />
                <Tab label="Kanban" />
            </Tabs>

            {tab === 0 ? <TabAsaas /> : <></>}
            {tab === 1 ? <TabKanban /> : <></>}
        </Templete>
    );
}
